import * as Service from '../service';

function prepBasicFormData(state) {
  const properties = ['cost', 'price', 'discount', 'vat', 'weight'];
  properties.forEach((prop) => {
    state.create.basic[prop] = parseFloat(state.create.basic[prop]).toFixed(2);
  });
}

function prepAttributesFormData(state, action) {
  // eslint-disable-next-line no-restricted-syntax
  for (const key of Object.keys(state[action].attributes)) {
    if (state[action].attributes[key].price > 0 && state[action].attributes[key].name) {
      state[action].attributes[key].price = parseFloat(state[action].attributes[key].price).toFixed(2);
    }

    if (!state[action].attributes[key].price) {
      state[action].attributes[key].price = 0.0;
    }
  }
}

function prepAvailableTime(state, action) {
  // eslint-disable-next-line no-restricted-syntax
  for (const key of Object.keys(state[action].available)) {
    if (state[action].available[key].dateRange) {
      state[action].available[key].available_from = state[action].available[key].dateRange[0];
      state[action].available[key].available_to = state[action].available[key].dateRange[1];
      delete state[action].available[key].dateRange;
    }
  }
}

function setCatalog(catalogs) {
  let data = {};
  catalogs.forEach((catalog, index) => {
    const response = {
      [index]: {
        category_id: catalog.category_id,
        sub_category_id: catalog.sub_category_id,
        micro_category_id: catalog.micro_category_id,
        item_id: catalog.item_id,
        id: catalog.id,
      },
    };

    data = { ...data, ...response };
  });
  return data;
}

function setOutlets(outlets) {
  let data = {};
  outlets.forEach((outlet, index) => {
    const response = {
      [index]: {
        quantity: outlet.quantity,
        outlet_id: outlet.outlet_id,
        item_id: outlet.item_id,
        id: outlet.id,
      },
    };

    data = { ...data, ...response };
  });
  return data;
}

function setAttributes(attributes) {
  let data = {};
  attributes.forEach((attribute, index) => {
    const response = {
      [index]: {
        name: attribute.name,
        price: attribute.price,
        attribute_group_id: attribute.group_id,
        item_id: attribute.item_id,
        id: attribute.id,
      },
    };

    data = { ...data, ...response };
  });
  return data;
}

function setAvailableTime(available) {
  let data = {};
  available.forEach((day, index) => {
    const response = {
      [index]: {
        dateRange: [day.available_from, day.available_to],
        available_day_id: day.available_day_id,
        item_id: day.item_id,
        id: day.id,
      },
    };

    data = { ...data, ...response };
  });

  return data;
}

function checkForEmptyObject(data) {
  for (const key of Object.keys(data)) {
    if (Object.keys(data[key]).length === 0) {
      delete data[key];
    }
  }

  return data;
}

export default {
  /**
   *
   * @param state
   * @returns {Promise<AxiosResponse<T>>}
   */
  async createItem({ state }) {
    prepBasicFormData(state);
    prepAvailableTime(state, 'create');
    prepAttributesFormData(state, 'create');

    return Service.createItem(state.create);
  },

  /**
   *
   * @param commit
   * @param state
   * @param page
   * @param limit
   * @param query
   * @returns {Promise<void>}
   */
  async fetchAllProducts({ commit, state }, { page, limit, query }) {
    let response = await Service.fetchAllProducts(page, limit, query, state.filter, state.direction);
    response = response.data.data;

    commit('setProperty', { property: 'pagination', payload: response.pagination });
    commit('setProperty', { property: 'products', payload: response ? response.data : [] });
  },

  /**
   *
   * @param state
   * @param dispatch
   * @param productId
   * @returns {Promise<void>}
   */
  async deleteProduct({ state, dispatch }, { productId }) {
    await Service.deleteProduct(productId);
    await dispatch('fetchAllProducts', { query: state.query, page: state.pagination.page, limit: state.pagination.perPage });
  },

  /**
   *
   * @param commit
   * @param productId
   * @returns {Promise<void>}
   */
  async fetchProduct({ commit }, { productId }) {
    const response = await Service.getProduct(productId);
    await commit('setActionProperty', { action: 'edit', parent: 'basic', payload: response });
    await commit('setActionProperty', { action: 'edit', parent: 'catalog', payload: setCatalog(response.itemCategories) });
    await commit('setActionProperty', { action: 'edit', parent: 'outlets', payload: setOutlets(response.itemOutlets) });
    await commit('setActionProperty', { action: 'edit', parent: 'attributes', payload: setAttributes(response.attributes) });
    await commit('setActionProperty', { action: 'edit', parent: 'available', payload: setAvailableTime(response.itemAvailableDay) });
    await commit('setActionProperty', { action: 'edit', parent: 'available', payload: setAvailableTime(response.itemAvailableDay) });

    const config = response.config ? response.config : { daily_order_limit: null, minimum_order: null };
    await commit('setActionProperty', { action: 'edit', parent: 'config', payload: config });

    await commit('setProperty', { property: 'images', payload: response.images });
  },

  /**
   *
   * @param dispatch
   * @param state
   * @param productId
   * @returns {Promise<void>}
   */
  async updateProductBasic({ dispatch, state }, { productId }) {
    await Service.updateProduct(productId, state.edit.basic);
    await dispatch('fetchProduct', { productId });
  },

  /**
   *
   * @param dispatch
   * @param state
   * @param productId
   * @param productSlug
   * @returns {Promise<void>}
   */
  async updateOrCreateItemCatalogItemOutlets({ dispatch, state }, { productId, productSlug }) {
    await Service.updateOrCreateItemCatalog(productId, { data: checkForEmptyObject(state.edit.catalog) });
    await Service.updateOrCreateItemOutlet(productId, { data: checkForEmptyObject(state.edit.outlets) });

    productId = productSlug;
    await dispatch('fetchProduct', { productId });
  },

  /**
   *
   * @param dispatch
   * @param productId
   * @param catalogId
   * @returns {Promise<void>}
   */
  async deleteItemCatalog({ dispatch }, { productId, catalogId }) {
    await Service.deleteItemCatalog(catalogId);
    await dispatch('fetchProduct', { productId });
  },

  /**
   *
   * @param dispatch
   * @param productId
   * @param outletId
   * @returns {Promise<void>}
   */
  async deleteItemOutlet({ dispatch }, { productId, outletId }) {
    await Service.deleteItemOutlet(outletId);
    await dispatch('fetchProduct', { productId });
  },

  /**
   *
   * @param dispatch
   * @param state
   * @param productId
   * @param productSlug
   * @returns {Promise<void>}
   */
  async updateOrCreateItemAttribute({ dispatch, state }, { productId, productSlug }) {
    prepAttributesFormData(state, 'edit');

    await Service.updateOrCreateItemAttribute(productId, { data: state.edit.attributes });

    productId = productSlug;
    await dispatch('fetchProduct', { productId });
  },

  /**
   *
   * @param dispatch
   * @param productId
   * @param attributeId
   * @returns {Promise<void>}
   */
  async deleteItemAttribute({ dispatch }, { productId, attributeId }) {
    await Service.deleteItemAttribute(attributeId);
    await dispatch('fetchProduct', { productId });
  },

  /**
   *
   * @param dispatch
   * @param state
   * @param productId
   * @param productSlug
   * @returns {Promise<void>}
   */
  async updateOrCreateItemConfigItemAvailableDay({ dispatch, state }, { productId, productSlug }) {
    prepAvailableTime(state, 'edit');

    await Service.updateItemConfig(state.edit.config.id, state.edit.config);
    await Service.updateOrCreateItemAvailableDay(productId, { data: checkForEmptyObject(state.edit.available) });

    productId = productSlug;
    await dispatch('fetchProduct', { productId });
  },

  /**
   *
   * @param dispatch
   * @param productId
   * @param configId
   * @returns {Promise<void>}
   */
  async deleteItemConfig({ dispatch }, { productId, configId }) {
    await Service.deleteItemConfig(configId);
    await dispatch('fetchProduct', { productId });
  },

  /**
   *
   * @param dispatch
   * @param productId
   * @param availableId
   * @returns {Promise<void>}
   */
  async deleteItemAvailableDay({ dispatch }, { productId, availableId }) {
    await Service.deleteItemAvailableDay(availableId);
    await dispatch('fetchProduct', { productId });
  },

  /**
   *
   * @param commit
   * @returns {Promise<void>}
   */
  async fetchPluckedProducts({ commit }) {
    const response = await Service.fetchPluckedProducts();
    commit('setProperty', { property: 'products', payload: response });
  },

  /**
   *
    * @param dispatch
   * @param imageId
   * @param productId
   * @returns {Promise<void>}
   */
  async deleteItemImage({ dispatch }, { imageId, productId }) {
    await Service.deleteItemImage(imageId);
    await dispatch('fetchProduct', { productId });
  },

  /**
   *
   * @param dispatch
   * @param formData
   * @returns {Promise<void>}
   */
  async applyBulkDiscount({ dispatch }, { formData }) {
    await Service.bulkDiscount(formData);
    await dispatch('fetchAllProducts', { page: 1, limit: 20 });
  },

  /**
   *
   * @param commit
   * @returns {Promise<void>}
   */
  async fetchCsvUploads({ commit }) {
    const response = await Service.getCsvUpload();
    commit('setProperty', { property: 'csvUploads', payload: response });
  },
};
